import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableHeader,
} from "../../../design/table";
import { Subheading } from "../../../design/heading";
import { useEvent } from "../../../contexts/EventContext";
import EmptyStateView from "../../../components/EmptyStateView";
import CreateEventButton from "../../../components/CreateEventButton/CreateEventButton";
import EventListItem from "../../EventListPage/components/EventListIItem";
import LoadingView from "../../../components/LoadingView";
import ErrorView from "../../../components/ErrorView";
import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { getSubdomainFromUrl } from "../../../utils/url";
import { db } from "../../../firebase";
import { Event } from "../../../models/Event";
import MatterEventListItem from "./MatterEventListItem";
import { Participant } from "../../../models/Participant";

interface MatterEventsListProps {
  matterId: string;
}

const MatterEventsList: React.FC<MatterEventsListProps> = ({ matterId }) => {
  const [events, setEvents] = useState<Event[]>([]);
  const [participants, setParticipants] = useState<Participant[]>([]);

  useEffect(() => {
    const tenantId = getSubdomainFromUrl(window.location.href);
    const docRef = query(
      collection(db, "tenants", tenantId, "matters", matterId, "events"),
      orderBy("eventDate", "desc"),
    );
    console.log("Fetching events for matter:", matterId);

    const unsubscribe = onSnapshot(
      docRef,
      (docSnapshot) => {
        if (docSnapshot.empty) {
          setEvents([]);
          return;
        }
        setEvents(
          docSnapshot.docs.map(
            (doc) => ({ _id: doc.id, ...doc.data() }) as Event,
          ),
        );
      },
      (err) => console.error("Failed to fetch events:", err.message),
    );
    return () => {
      unsubscribe();
    };
  }, [matterId]);

  useEffect(() => {
    const tenantId = getSubdomainFromUrl(window.location.href);
    const docRef = query(
      collection(db, "tenants", tenantId, "matters", matterId, "participants"),
    );
    const unsubscribe = onSnapshot(
      docRef,
      (docSnapshot) => {
        console.log("Fetching participants for matter:", matterId);
        if (docSnapshot.empty) {
          setParticipants([]);
          return;
        }
        setParticipants(
          docSnapshot.docs.map(
            (doc) => ({ _id: doc.id, ...doc.data() }) as Participant,
          ),
        );
      },
      (err) => console.error("Failed to fetch participants:", err.message),
    );
    return () => {
      unsubscribe();
    };
  }, [matterId]);

  if (!events) {
    return <ErrorView error={new Error("Events not found")} />;
  }

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <Subheading>Events</Subheading>
      </div>
      {events.length === 0 && (
        <EmptyStateView title="No Events" message="No events found" />
      )}
      {events.length > 0 && (
        <>
          <Table className="mt-8 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
            <TableHead>
              <TableRow>
                <TableHeader>Date</TableHeader>
                <TableHeader>People Involved</TableHeader>
                <TableHeader>Type</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {events.map((event) => (
                <MatterEventListItem
                  key={event._id}
                  event={event}
                  participants={participants}
                />
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </div>
  );
};

export default MatterEventsList;
